/* =========================================================
   JSM — Recherche (maquette A2)
   - Intercepte le bouton de recherche du header
   - Moteur : Shopify Predictive Search API (/search/suggest)
   - Rendu : section jsm-recherche-resultats
   - Recherches récentes : localStorage (5 max)
   - Navigation aux flèches + Entrée (repris du natif Horizon)
   ========================================================= */
(() => {
  const root = document.getElementById('JsmRecherche');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  // Sortir le panneau du header (évite les pièges de z-index / transform)
  document.body.appendChild(root);

  const panel = root.querySelector('.jsm-r__panneau');
  const form = root.querySelector('.jsm-r__barre');
  const input = root.querySelector('#JsmRechercheChamp');
  const emptyEl = root.querySelector('[data-jsm-r-empty]');
  const resultsEl = root.querySelector('[data-jsm-r-results]');
  const recentsWrap = root.querySelector('[data-jsm-r-recents]');
  const recentsList = root.querySelector('[data-jsm-r-recents-list]');
  const recentsClear = root.querySelector('[data-jsm-r-recents-clear]');

  const KEY = 'jsm:recherches';
  const MAX_RECENTS = 5;
  const DELAI = 220;
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const searchUrl = root.dataset.searchUrl || '/search';
  const triggerSel = root.dataset.trigger || '[data-jsm-recherche-ouvrir]';
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  const ICON_CLOCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';

  let lastTrigger = null;
  let ctrl = null;
  let timer = null;
  let exactUrl = '';
  let closeTimer = null;
  let actif = -1;

  /* ---------- Recherches récentes ---------- */
  function getRecents() {
    try {
      const v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    try {
      const list = getRecents().filter((x) => x.toLowerCase() !== q.toLowerCase());
      list.unshift(q);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_RECENTS)));
    } catch (e) {}
  }

  function renderRecents() {
    if (!recentsList) return;
    const list = getRecents();
    recentsList.replaceChildren();
    list.forEach((q) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'jsm-r__recent';
      a.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
      a.dataset.jsmRRecent = q;
      a.innerHTML = ICON_CLOCK;
      a.append(document.createTextNode(q));
      li.append(a);
      recentsList.append(li);
    });
    recentsWrap.hidden = list.length === 0;
  }

  /* ---------- Position sous le header (desktop) ---------- */
  function setTop() {
    if (!mqDesktop.matches) {
      root.style.setProperty('--jsm-r-top', '0px');
      return;
    }
    const trigger =
      (lastTrigger && lastTrigger.isConnected && lastTrigger.closest && lastTrigger) ||
      document.querySelector('.search-action');
    let bottom = 0;
    if (trigger) {
      // Section Shopify qui contient la loupe = le header complet (sticky compris)
      const section = trigger.closest('.shopify-section') || trigger.closest('header');
      if (section) bottom = section.getBoundingClientRect().bottom;
      // Sécurité : jamais au-dessus de la loupe elle-même
      bottom = Math.max(bottom, trigger.getBoundingClientRect().bottom + 12);
    }
    root.style.setProperty('--jsm-r-top', Math.max(0, Math.round(bottom)) + 'px');
  }

  /* ---------- Header transparent ----------
     Horizon peut rendre le header transparent au-dessus de la 1re section.
     Pendant la recherche, on retire temporairement ce mode pour que
     le header redevienne plein (fond + logo + couleurs natives), puis on le rétablit. */
  const ATTRS_TRANSPARENT = ['transparent', 'data-transparent'];
  let headerTransparent = null;
  let valeursTransparent = {};

  function trouverHeader() {
    const t =
      (lastTrigger && lastTrigger.isConnected && lastTrigger.closest && lastTrigger) ||
      document.querySelector('.search-action');
    return (
      (t && t.closest('header-component, #header-component, [transparent], [data-transparent]')) ||
      document.querySelector('#header-component, header-component')
    );
  }

  function headerPlein() {
    const h = trouverHeader();
    if (!h) return;
    valeursTransparent = {};
    ATTRS_TRANSPARENT.forEach((a) => {
      if (h.hasAttribute(a)) {
        valeursTransparent[a] = h.getAttribute(a);
        h.removeAttribute(a);
      }
    });
    headerTransparent = Object.keys(valeursTransparent).length ? h : null;
  }

  function headerRetabli() {
    if (!headerTransparent) return;
    Object.keys(valeursTransparent).forEach((a) => {
      headerTransparent.setAttribute(a, valeursTransparent[a]);
    });
    headerTransparent = null;
    valeursTransparent = {};
  }

  /* ---------- Ouverture / fermeture ---------- */
  function isOpen() {
    return root.classList.contains('is-open');
  }

  function open(trigger) {
    clearTimeout(closeTimer);
    lastTrigger = trigger || document.activeElement;
    headerPlein();
    setTop();
    renderRecents();
    root.hidden = false;
    document.documentElement.classList.add('jsm-r-lock');
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      input.focus({ preventScroll: true });
      if (input.value) input.select();
    });
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('jsm-r-lock');
    headerRetabli();
    if (ctrl) ctrl.abort();
    closeTimer = setTimeout(() => {
      root.hidden = true;
    }, 200);
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  /* ---------- États ---------- */
  function showEmpty() {
    if (ctrl) ctrl.abort();
    exactUrl = '';
    actif = -1;
    resultsEl.hidden = true;
    resultsEl.replaceChildren();
    emptyEl.hidden = false;
    input.setAttribute('aria-expanded', 'false');
    renderRecents();
  }

  function showError() {
    resultsEl.innerHTML =
      '<div class="jsm-rr"><p class="jsm-rr__message">La recherche ne répond pas pour le moment.</p>' +
      '<p class="jsm-rr__aide">Appuyez sur Entrée pour afficher la page de résultats.</p></div>';
    emptyEl.hidden = true;
    resultsEl.hidden = false;
  }

  /* ---------- Requête ---------- */
  async function fetchResults(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();

    const params = new URLSearchParams();
    params.set('q', q);
    params.set('section_id', root.dataset.section || 'jsm-recherche-resultats');
    params.set('resources[type]', 'product,query,collection');
    params.set('resources[limit]', root.dataset.limit || '4');
    params.set('resources[limit_scope]', 'each');
    // Pertinence d'abord : un produit épuisé n'est plus relégué en fin de liste
    params.set('resources[options][unavailable_products]', 'show');
    params.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,tag,vendor');

    root.classList.add('is-loading');
    try {
      const res = await fetch(base + 'search/suggest?' + params.toString(), {
        signal: ctrl.signal,
        headers: { Accept: 'text/html' },
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      if (input.value.trim() !== q) return; // réponse périmée

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const frag = doc.querySelector('.jsm-rr');
      resultsEl.replaceChildren();
      if (frag) resultsEl.append(document.importNode(frag, true));
      // Lien « Devenir revendeur » réglé dans le customizer
      if (root.dataset.lienAcces) {
        resultsEl.querySelectorAll('[data-jsm-r-acces]').forEach((a) => {
          a.href = root.dataset.lienAcces;
        });
      }
      exactUrl = frag ? frag.dataset.exactUrl || '' : '';
      actif = -1;
      emptyEl.hidden = true;
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    } catch (e) {
      if (e.name !== 'AbortError') showError();
    } finally {
      root.classList.remove('is-loading');
    }
  }

  function onInput() {
    const q = input.value.trim();
    clearTimeout(timer);
    if (!q) {
      showEmpty();
      return;
    }
    timer = setTimeout(() => fetchResults(q), DELAI);
  }

  function runSearch(q) {
    input.value = q;
    onInput();
    input.focus({ preventScroll: true });
  }

  /* ---------- Navigation clavier ---------- */
  function navItems() {
    return Array.from(resultsEl.querySelectorAll('.jsm-rr__cote a, .jsm-rr__carte .jsm-rr__media-lien')).filter(
      (el) => el.offsetParent !== null
    );
  }

  function setActif(i) {
    const list = navItems();
    list.forEach((el) => el.classList.remove('is-actif'));
    if (!list.length) {
      actif = -1;
      return;
    }
    actif = (i + list.length) % list.length;
    const el = list[actif];
    el.classList.add('is-actif');
    el.scrollIntoView({ block: 'nearest' });
  }

  /* ---------- Événements ---------- */
  input.addEventListener('input', onInput);

  input.addEventListener('keydown', (e) => {
    if (resultsEl.hidden) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActif(actif + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActif(actif - 1);
    } else if (e.key === 'Enter' && actif >= 0) {
      const el = navItems()[actif];
      if (el) {
        e.preventDefault();
        saveRecent(el.dataset.jsmRTerme || input.value);
        window.location.href = el.href;
      }
    }
  });

  form.addEventListener('submit', (e) => {
    const q = input.value.trim();
    if (!q) {
      e.preventDefault();
      return;
    }
    saveRecent(q);
    if (exactUrl) {
      e.preventDefault();
      window.location.href = exactUrl;
    }
  });

  if (recentsClear) {
    recentsClear.addEventListener('click', () => {
      try {
        localStorage.removeItem(KEY);
      } catch (e) {}
      renderRecents();
      input.focus();
    });
  }

  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-jsm-r-close]')) {
      e.preventDefault();
      close();
      return;
    }

    // Recherche récente ou fréquente → relance dans le panneau
    const terme = e.target.closest('[data-jsm-r-recent], .jsm-r__liste--frequentes [data-jsm-r-terme]');
    if (terme) {
      e.preventDefault();
      runSearch(terme.dataset.jsmRRecent || terme.dataset.jsmRTerme);
      return;
    }

    // Clic sur un résultat → mémorise la recherche
    const lien = e.target.closest('.jsm-r__resultats a');
    if (lien) saveRecent(lien.dataset.jsmRTerme || input.value);
  });

  // Échap + piège de focus
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusables = Array.from(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')
    ).filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Interception du bouton de recherche natif
  // Sur window en phase de capture : passe AVANT les écouteurs délégués d'Horizon
  window.addEventListener(
    'click',
    (e) => {
      let t = null;
      try {
        t = e.target.closest(triggerSel);
      } catch (err) {
        return; // sélecteur invalide dans le customizer
      }
      if (t && !root.contains(t)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (isOpen()) close();
        else open(t);
        return;
      }
      // Clic ailleurs dans le header (menu, compte, panier…) : on referme
      // la recherche et on laisse le clic faire son action normale
      if (isOpen() && !root.contains(e.target)) close();
    },
    true
  );

  // Survol du menu principal (desktop) : la recherche se referme
  // pour laisser le mega-menu s'afficher
  document.addEventListener('mouseover', (e) => {
    if (!isOpen() || !mqDesktop.matches) return;
    const lien = e.target.closest && e.target.closest('header-menu a, header nav a, header-menu button, header nav button');
    if (lien && !root.contains(lien)) close();
  });

  // Désactive l'ordre d'ouverture natif sur les loupes Horizon
  function neutraliserNatif() {
    document.querySelectorAll('[on\\:click*="search-modal"]').forEach((el) => {
      el.removeAttribute('on:click');
      el.setAttribute('data-jsm-recherche-ouvrir', '');
    });
  }
  neutraliserNatif();
  // Le customizer re-rend le header à chaque modification : on recommence
  document.addEventListener('shopify:section:load', neutraliserNatif);

  // Filet de sécurité : si la fenêtre native s'ouvre quand même, on la referme
  const dialogNatif = document.querySelector('#search-modal dialog');
  if (dialogNatif) {
    new MutationObserver(() => {
      if (dialogNatif.open) {
        dialogNatif.close();
        if (!isOpen()) open();
      }
    }).observe(dialogNatif, { attributes: true, attributeFilter: ['open'] });
  }

  // Ouverture programmatique : document.dispatchEvent(new CustomEvent('jsm:recherche:ouvrir'))
  document.addEventListener('jsm:recherche:ouvrir', () => open());

  window.addEventListener('resize', () => {
    if (isOpen()) setTop();
  });
  mqDesktop.addEventListener('change', () => {
    if (isOpen()) setTop();
  });

  // Retour arrière (bfcache) : panneau refermé proprement
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('jsm-r-lock');
      headerRetabli();
    }
  });
})();